import { handleActions } from 'redux-actions';
import moment from 'moment';

import createCalendar, { getDateRangeFromCalendar } from '../shared/calendar';
import createFilters, { getFiltersObject } from '../shared/filters';
import http from '../shared/http';

import endpoints from '../../config/endpoints';

export const namespace = 'weeklyReport';

const calendar = createCalendar({
	namespace,
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(21, 'days').startOf('isoWeek').format('YYYY-MM-DD'),
		end: moment().endOf('isoWeek').format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace,
	stateNodeName: 'filters',
	listOfFilters: [
		{
			name: 'managers',
			title: 'Managers',
			placeholder: 'Add managers',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: true,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.ADMINS + '?role=manager'
			}
		}
	]
});

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
const APPLY = `${namespace}/apply`;
const CLEAR = `${namespace}/clear`;

// initial state
const initialState = {
	isLoading: true,
	isError: false,
	data: null,
	filters: filters.initialState,
	calendar: calendar.initialState
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			request(getRequestQuery(getState), FETCH_DATA_SUCCESS)(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	},
	apply: () => (dispatch, getState) => {
		dispatch({ type: APPLY });
		dispatch(actions.own.fetchData());
	},
	clear: () => (dispatch, getState) => {
		dispatch({ type: CLEAR });
		dispatch(actions.own.fetchData());
	},
	filters: filters.actions,
	calendar: calendar.actions
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const weeks = getWeeks(getDateRangeFromCalendar(state.calendar));

			return {
				...state,
				data: {
					...action.payload.data,
					weeks
				},
				isLoading: false,
				isError: false
			};
		},
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		}),
		[APPLY]: (state, action) => ({
			...state,
			data: null,
			isLoading: true
		}),
		[CLEAR]: (state, action) => initialState
	},
	filters.reducers,
	calendar.reducers
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getFilters: state => filters.selectors.getFilters(
		state => state[namespace].filters,
		state => state
	)(state),
	getCalendar: state => calendar.selectors.getCalendar(
		state => state[namespace].calendar,
		state => state
	)(state)
};

function getRequestQuery(getState) {
	const state = getState()[namespace];

	const range = getDateRangeFromCalendar(state.calendar);
	const filters = getFiltersObject(state.filters, false);
	const inverse_filters = getFiltersObject(state.filters, true);

	return {
		dates: [range.start, range.end],
		filters,
		inverse_filters
	};
}

function request(query, successActionType) {
	return http({
		url: 'v2/weekly-report',
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}

function getWeeks(range) {
	const start = moment(range.start).startOf('week');
	const end = moment(range.end).startOf('week');

	const n = end.diff(start, 'week');

	return Array.from({ length: n + 1 }, (_, i) => start.clone().add(i, 'week'));
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/weekly-report/index.js